var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',{staticClass:"component case-base-info panel default-background"},[_c('account-info'),_c('card-info'),_c('customer-detail-info'),_c('card-other-info')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }